import React, { useContext, useState } from "react"
// import media from "cssMix/index"
import styled from "styled-components"
import { ContextStore } from "Reducer"
import { useTranslation } from "react-i18next"
import { List } from "immutable"
import media from "cssMix/index"
import PayoutRankTable from "./PayoutRankTable"
import Footer from "Components/Main/Footer"
import ReactModal from "Components/common/ReactModal"
import useMediaQuery from "useHooks/useMediaQuery"
//style
import {
  RankMain,
  RankMainContainer,
  MaxWidthContainer,
} from "Components/common/MainStyled"
const InfoPopup = styled.div`
  width: 90%;
  max-width: 520px;
  padding: 54px 60px;
  z-index: 100;
  border-radius: 8px;
  box-sizing: border-box;
  background-color: #fff;
  ${media.tablet`
    padding:48px;
  `}
  ${media.mobile`
    padding:24px;
  `}
  & .title {
    font-size: 16px;
    font-weight: 600;
    color: #d02a43;
    margin-bottom: 16px;
  }
  & .content {
    & p {
      font-size: 16px;
      color: #141620;
      margin-bottom: 0;
      & .highlight {
        color: #d02a43;
      }
      ${media.mobile`
        font-size:14px;
      `}
    }
  }
`
const PayoutRank = ({ homeScrollTop }) => {
  const {
    state: { stateReducer },
  } = useContext(ContextStore)
  const { t } = useTranslation()
  const [rankSort, setRankSort] = useState(true)
  const [isInfoOpen, setIsInfoOpen] = useState(false)
  const { mediaType } = useMediaQuery()
  const mainAreaRoute = stateReducer.get("mainAreaRoute")
  const rankSortHandler = () => {
    setRankSort(!rankSort)
  }
  const payoutRank = rankSort
    ? stateReducer
        .get("payoutRank", List())
        .sort((a, b) => a.get("topGamesRank") - b.get("topGamesRank"))
    : stateReducer
        .get("payoutRank", List())
        .sort((a, b) => b.get("topGamesRank") - a.get("topGamesRank"))
  const column = mediaType === "mobile" ? 1 : Math.ceil(payoutRank.size / 10)
  const gameList = stateReducer.get("gameList", List())
  const lang = stateReducer.get("lang")
  const infoHandler = () => {
    setIsInfoOpen(!isInfoOpen)
  }

  return (
    <RankMainContainer mainAreaRoute={mainAreaRoute}>
      <MaxWidthContainer>
        <RankMain column={column} mainAreaRoute={mainAreaRoute}>
          <div className="title-container">
            <p className="title">{t("payoutRank")}</p>
            <i className="bx bx-info-circle info" onClick={infoHandler} />
          </div>
          <div className="rank-container">
            {Array.from({ length: column }, (v, i) => i).map((v) => (
              <PayoutRankTable
                key={v}
                t={t}
                rankSort={rankSort}
                rankSortHandler={rankSortHandler}
                startRank={v * 10}
                payoutRank={payoutRank}
                gameList={gameList}
                lang={lang}
                column={column}
                homeScrollTop={homeScrollTop}
              />
            ))}
          </div>
          <Footer />
        </RankMain>
        <ReactModal
          isOpen={isInfoOpen}
          onModalClose={() => setIsInfoOpen(false)}
        >
          <InfoPopup>
            <div className="title">{t("payoutInfo.title")}</div>
            <div className="content">
              <p
                dangerouslySetInnerHTML={{ __html: t("payoutInfo.content.0") }}
              />
              <p
                dangerouslySetInnerHTML={{ __html: t("payoutInfo.content.1") }}
              />
            </div>
          </InfoPopup>
        </ReactModal>
      </MaxWidthContainer>
    </RankMainContainer>
  )
}

export default PayoutRank
